// Routes owned by the Promo module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const promoPaths = {
    // Promos
    promosList: '/promos',
    promoCreate: '/promos/new',
    promoDetail: '/promos/:id',
} as const
